<p-dropdown [options]="list" [placeholder]="holder" [(ngModel)]="selecteddata" (onChange)="selectedData()" optionLabel="name">

</p-dropdown>
